export const delFromObj = (obj, key) => {
    const newObj = { ...obj };
    delete newObj[key];
    return newObj;
}